import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { Heading } from '../Heading';
import { HeaderContainer } from './styles';
import { NavButton } from './NavButton';

export const Header = ({ date, decreaseMonth, increaseMonth }) => (
  <HeaderContainer>
    <NavButton type="back" onClick={decreaseMonth} />
    <Heading
      position="center"
      typography="heading2"
      headingLevel="h6"
      headingText={`${format(date, 'LLLL')} ${format(date, 'yyyy')}`}
    />
    <NavButton type="forward" onClick={increaseMonth} />
  </HeaderContainer>
);

Header.displayName = 'Header';
Header.propTypes = {
  date: PropTypes.object.isRequired,
  decreaseMonth: PropTypes.func.isRequired,
  increaseMonth: PropTypes.func.isRequired,
};
